<template>
    <img src="@/assets/images/arrow-right.svg" class="justify-content-end" style="width: 18px;height: 18px; position: absolute; right: 14px; top: 10px; cursor: pointer;" @click="CheckkDetail()"/>
  </template>
  
  <script>
  export default {
    name:"ButtonPage",
    mounted() {
    },
    methods: {
      CheckkDetail() {
        this.$store.state.PassHistory.AER_SERVICE_JOB_ID = this.params.data.AER_SERVICE_JOB_ID;
        this.$store.state.PassHistory.REQUEST_NO = this.params.data.REQUEST_NO;
        this.$store.state.PassHistory.FSYSTEM = this.params.data.FSYSTEM;
        this.$store.state.PassHistory.FSYSTEM_DT_TEXT = this.params.data.FSYSTEM_DT_Text;
        this.$store.state.PassHistory.JOB_DESC = this.params.data.JOB_DESC;
        this.$store.state.PassHistory.STATUS_DESC = this.params.data.STATUS_DESC;
        this.$store.state.PassHistory.SUB_STATUS_DESC = this.params.data.SUB_STATUS_DESC;
        this.$store.state.PassHistory.JOB = this.params.data.JOB;
        this.$store.state.PassHistory.SUBJOB = this.params.data.SUBJOB;
        this.$store.state.PassHistory.STATUS = this.params.data.STATUS;
        this.$store.state.PassHistory.SUB_STATUS = this.params.data.SUB_STATUS;
        this.$store.state.PassHistory.STATUS_ID_TEXT = this.params.data.STATUS_ID_TEXT;
        this.$store.state.PassHistory.STATUS_DT_TEXT = this.params.data.STATUS_DT_TEXT;
        this.$store.state.PassHistory.REMARKS = this.params.data.REMARKS;
  
        this.$router.push('/ProspectHistoryDetail');
      }
    }
  }
  </script>
  
  <style>
  
  </style>